export class Banners {
	init() {
		const bannerCloseButtons = document.querySelectorAll<HTMLDivElement>(
			"body > .alert .btn-close, .gdpr-alert .btn-close"
		);

		bannerCloseButtons.forEach(closeButton => {
			closeButton.addEventListener("click", () => {
				const parentElement = closeButton.parentElement;
				if (!parentElement) {
					return;
				}

				parentElement.style.display = "none";

				if (parentElement.classList.contains("gdpr-alert")) {
					document.cookie = "GDPRAlert=True";
				}
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const banners = new Banners();
	banners.init();
});
